import React from "react";
import { Col, Row, Container, Badge, Form } from "react-bootstrap";
import { NavObjectType } from "../../Components/navigationTypes";
import { getDataReader, RPWDataReader, XMLJSON } from "../../livedataFuncs";

interface IProps {
    datarootContainer: any,
    page: NavObjectType,
    sidebarshow: string,
    toggleState: boolean,
}

export class RightSideHistory extends React.Component<IProps> {
    render() {
        let drawerClasses = ''
        if (this.props.sidebarshow === 'History' && this.props.toggleState === true) {
            drawerClasses = ' open'
        }
        let historyNodes: Array<XMLJSON>;
        let creationDate: Array<XMLJSON>;
        if (this.props.datarootContainer?.dataRoot) {
            const DataReaderObj: RPWDataReader = getDataReader(this.props.datarootContainer?.dataRoot);
            creationDate = DataReaderObj.getTPAppXMLNode();
            historyNodes = DataReaderObj.getNodeInformation('ModifyHistory');
        }
        const hasHistory = historyNodes && historyNodes.length > 0;
        return (
            <div className={"toolbar-content " + drawerClasses} key={hasHistory ? 'history' : 'no-history'}>
                <div className="toolbar-header">
                    <h3>File History</h3>
                </div>
                <div className="toolbar-body">
                    {hasHistory ? historyNodes[0].children.map((object: XMLJSON, index) => this.mainHistoryItems(object, index)) : null}
                    {creationDate?.map((object: XMLJSON, index) => this.creationDateItem(object, index))}
                </div>
            </div>
        )
    }
    /**
 * 
 * @param TPAppXMLNode xml node with information
 * @param index used as key
 */
    creationDateItem(TPAppXMLNode: XMLJSON, index: number) {
        return (
            <div key={'creation-date'}>
                <Container key={`createdkey-${index}`} className="history-item gx-0">
                    <Row className="gx-0">
                        <Col md="auto">
                            <i className="fa-light fa-square-dashed-circle-plus"></i>
                        </Col>
                        <Col>
                            <b>{TPAppXMLNode.attributes.CreatedBy}</b>
                        </Col>
                        <Col md="auto" className="align-right">
                            <Badge bg="primary" text="light">Created</Badge>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form.Label style={{paddingLeft:"21px"}}>{TPAppXMLNode.attributes.CreationDate}</Form.Label>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
    /**
     * 
     * @param historyNode xml node with information
     * @param index used as key
     * @returns div with history information
     */
    mainHistoryItems(historyNode: XMLJSON, index: number) {
        const isSolunoEntry = historyNode.attributes.Application === 'Soluno';
        
        return (
            <Container key={`history-${index}`} className="history-item gx-0">
                <Row className="gx-0">
                    <Col md="auto">
                        <i className={isSolunoEntry ? 
                            "fa-light fa-file-export" : 
                            "fa-light fa-pen-to-square"}>
                        </i>
                    </Col>
                    <Col>
                        <b>{historyNode.attributes.LastModifiedBy}</b>
                    </Col>
                    <Col md="auto" className="align-right">
                        {isSolunoEntry ? (
                            <Badge bg="success" text="light">Soluno</Badge>
                        ) : (
                            <Badge bg="info" text="dark">Modified</Badge>
                        )}
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Label style={{paddingLeft:"21px"}}>
                            {historyNode.attributes.LastModifiedDate}
                        </Form.Label>
                    </Col>
                </Row>
            </Container>
        )
    }
}